/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automation_Condition_ValueInputs */

const cs_automation_condition_value = /** @type {(inputs: Automation_Condition_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hodnota`)
};

const en_automation_condition_value = /** @type {(inputs: Automation_Condition_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Value`)
};

/**
* | output |
* | --- |
* | "Value" |
*
* @param {Automation_Condition_ValueInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const automation_condition_value = /** @type {((inputs?: Automation_Condition_ValueInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Condition_ValueInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_condition_value(inputs)
	return cs_automation_condition_value(inputs)
});